export const DISPATCH_BOARD_VEHICLE_TYPE_COOKIE = 'dispatchBoardVehicleTypeId';
export const DISPATCH_BOARD_VEHICLE_TYPE_COOKIE_EXPIRATION = 365;
